import React from 'react';
import InfiniteCarousel from 'react-leaf-carousel';
import SliderItem from '../SliderItem';
import SliderItemMobile from '../SliderItemMobile';

const Slider = ({title,articulos,showPrice,showTallas}) => {
    let sortArticulos = showTallas ? articulos : articulos.sort((a, b) => 0.5 - Math.random()).slice(0, 10);

    return (
        <div className="accessories">
            <h2>{title}</h2>

            <div className="accessories_movil row row-cols-2 row-cols-sm-3">
                {
                    sortArticulos.map( (item,i) => 
                        item.activo &&
                            <SliderItemMobile
                                articulo={item}
                                key={"sIM_"+i}
                                showPrice={showPrice}
                                showTallas={showTallas}
                            />
                    )
                }

                {/*
                    <div className="col-12 my-4 v-align-c"><button className="accessories__more">Ver más</button></div>
                */}
            </div>

            
            <InfiniteCarousel
                breakpoints={
                    [
                        {
                            breakpoint: 500,
                            settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            },
                        },
                    ]
                }
                dots={false}
                showSides={false}
                sidesOpacity={0.5}
                sideSize={0.1}
                slidesToScroll={1}
                slidesToShow={4}
                scrollOnDevice={true}
            >

                {
                    sortArticulos.map( (item,i) => 
                        item.activo &&
                            <SliderItem
                                articulo={item}
                                key={"sID_"+i}
                                showPrice={showPrice}
                                showTallas={showTallas}
                            />
                    )
                }
                
                
            </InfiniteCarousel>
        </div>
    );
};

export default Slider;